import { gql } from "@apollo/client";

export const CREATE_CUSTOMER = gql`
  mutation CreateCustomerMutation($input: CreateCustomerInput!) {
    createCustomer(input: $input) {
      ok
      error
      id
    }
  }
`;

export const UPDATE_CUSTOMER = gql`
  mutation UpdateCustomerMutation($id: Int!, $input: UpdateCustomerInput!) {
    updateCustomer(id: $id, input: $input) {
      ok
      error
    }
  }
`;

export const REMOVE_CUSTOMER = gql`
  mutation RemoveCustomerMutation($id: Int!) {
    removeCustomer(id: $id) {
      ok
      error
    }
  }
`;

export const MARK_CUSTOMER = gql`
  mutation MarkCustomerMutation($id: Int!) {
    markCustomer(id: $id) {
      ok
      error
    }
  }
`;

export const UNMARK_CUSTOMER = gql`
  mutation UnmarkCustomerMutation($id: Int!) {
    unmarkCustomer(id: $id) {
      ok
      error
    }
  }
`;

export const BULK_IMPORT_CUSTOMERS = gql`
  mutation BulkImportCustomersMutation($input: BulkImportCustomersInput!) {
    bulkImportCustomers(input: $input) {
      ok
      error
      createdCount
      skippedCount
      createdIds
    }
  }
`;

export const CUSTOMER = gql`
  query CustomerQuery($id: Int!) {
    customer(id: $id) {
      ok
      error
      result {
        id
        name
        email
        phone
        status
        site
        address
        postalCode
        city
        findBy
        todo
        note
        hidden
        analyseDone
        problemsDetected
        automaticEmailsSentCount
        marked
        markedById
        markedBy {
          id
          firstname
          lastname
          email
        }
        categoryId
        category {
          id
          name
        }
        cmsId
        cms {
          id
          name
        }
        createdSites {
          id
          url
          status
          creationPercentage
          createdAt
          triggeredBy {
            id
            firstname
            lastname
          }
        }
      }
    }
  }
`;

export const CUSTOMERS = gql`
  query CustomersQuery($where: CustomersFiltersInput!) {
    customers(where: $where) {
      ok
      error
      hasMore
      total
      results {
        id
        name
        email
        phone
        status
        site
        address
        postalCode
        city
        findBy
        hidden
        analyseDone
        problemsDetected
        marked
        markedById
        markedBy {
          id
          firstname
          lastname
          email
        }
        cms {
          id
          name
        }
      }
    }
  }
`;
